import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product-list/product-listing-shell.tsx");
